module.exports = __webpack_public_path__ + "img/arrow-left.43f6999c.svg";